import { combineReducers } from 'redux';
import userSettings from './userSettingsSlice';

const settingsReducer = combineReducers({
  userSettings,
});

export default settingsReducer;
